import { render } from "./virtualPersonDetail.vue?vue&type=template&id=3e74148d&scoped=true"
import script from "./virtualPersonDetail.vue?vue&type=script&lang=js"
export * from "./virtualPersonDetail.vue?vue&type=script&lang=js"

import "./virtualPersonDetail.vue?vue&type=style&index=0&id=3e74148d&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e74148d"]])

export default __exports__